import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import startOfMonth from 'date-fns/startOfMonth';
import startOfWeek from 'date-fns/startOfWeek';
import { BookingRange } from '../../types';

const DaysInMonthGrid = 6 * 7;

export function monthGridRange(dayInMonth: Date): BookingRange {
    let start = startOfWeek(startOfMonth(dayInMonth), { weekStartsOn: 1 });
    return {
        start: format(start, 'yyyy-MM-dd'),
        end: format(addDays(start, DaysInMonthGrid), 'yyyy-MM-dd')
    };
}
